'use client'
/**
 * Add-to-cart control. Two layouts:
 *   - compact (default): a single "Add to cart" button (homepage cards).
 *   - withQty: a quantity stepper + button (product detail page).
 *
 * On add it pushes to the server cart via CartContext and opens the drawer so
 * the action has a visible result.
 */
import { useState } from 'react'
import { useCart } from '@/lib/cart/CartContext'
import { useLanguage } from '@/lib/context/LanguageContext'
import QtyStepper from './QtyStepper'

export default function AddToCart({
  slug,
  withQty = false,
  className = '',
}: {
  slug: string
  withQty?: boolean
  className?: string
}) {
  const { addBySlug, open, busy } = useCart()
  const { t } = useLanguage()
  const [qty, setQty] = useState(1)
  const [justAdded, setJustAdded] = useState(false)

  async function add() {
    await addBySlug(slug, qty)
    setJustAdded(true)
    open()
    window.setTimeout(() => setJustAdded(false), 1600)
  }

  return (
    <div className={'flex items-center gap-3 ' + className}>
      {withQty && <QtyStepper value={qty} onChange={setQty} disabled={busy} />}
      <button
        type="button"
        onClick={add}
        disabled={busy}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-action px-6 py-2.5 text-sm font-semibold text-surface hover:bg-accent disabled:opacity-60 transition-colors"
      >
        {justAdded ? t.shop.added : t.shop.addToCart}
      </button>
    </div>
  )
}
